import React, { useEffect } from 'react';
import Layout from './layout';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/home';
import WithdrawalSettings from './pages/withdrawalSettings';
import { Toaster } from 'react-hot-toast';
import { store } from './redux/store';
import { Provider } from 'react-redux';

function App() {
  useEffect(() => {

    const handleUnload = () => {
      localStorage.clear(); 
    };

    window.addEventListener('beforeunload', handleUnload);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/home" />} />
            <Route path="/home" element={<Home />} />
            <Route path="/withdrawal-settings" element={<WithdrawalSettings />} />
          </Route>
        </Routes>
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerStyle={{}}
          toastOptions={{
            className: 'animate-slide-down',
            duration: 3000,
            style: {
              border: '2px solid #1dd1a1',
              textTransform: 'capitalize',
              boxShadow: '5px 5px 10px rgba(0, 0, 10, 1)',
              background: '#fff',
              fontWeight: 'bold',
              color: '#000',
            },
            success: {
              duration: 2000,
              theme: {
                primary: 'green',
                secondary: 'black',
              },
            },
          }}
        />
      </Router>
    </Provider>
  );
}

export default App;
